import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spb-springboard-component-library',
  template: `
    <p>
      springboard-component-library works!
    </p>
  `,
  styles: []
})
export class SpringboardComponentLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
